/**
 * The Journal's clasp (journal redesign 2026-10-27, "Private by design").
 *
 * Opt-in. When it is on, the server sends no pages until it is opened (with a
 * passkey or the PIN), and answers with an unlock token. The token lives here,
 * in memory only: a reload, leaving the Journal, or five minutes with the app
 * out of sight shuts it again. It locks the Journal only, not the app.
 */
import { reactive } from 'vue'

export const AWAY_MS = 5 * 60 * 1000

export const clasp = reactive({ token: '', open: false })

export function openClasp (token) {
  clasp.token = token || ''
  clasp.open = !!token
}

export function shutClasp () {
  clasp.token = ''
  clasp.open = false
}

/**
 * Shut the clasp after AWAY_MS with the app hidden. Returns the cleanup.
 * `onShut` is told so the book can swing its cover closed.
 */
export function watchAway (onShut) {
  let hiddenAt = 0
  const onVis = () => {
    if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return }
    if (hiddenAt && Date.now() - hiddenAt >= AWAY_MS && clasp.open) {
      shutClasp()
      onShut && onShut()
    }
    hiddenAt = 0
  }
  document.addEventListener('visibilitychange', onVis)
  return () => document.removeEventListener('visibilitychange', onVis)
}
